var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lost"},[_vm._v("\n  The page you're looking for is not found.\n")])}
var staticRenderFns = []

export { render, staticRenderFns }